import * as intl from "react-intl";

export const DEFAULT_LOCALE = "en";

export const cache = intl.createIntlCache();

export const createIntl = (
  config: intl.IntlConfig = { locale: DEFAULT_LOCALE },
) => {
  return intl.createIntl(config, cache);
};
